var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWeatherStrongWind = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 24,
  fill: "none",
  viewBox: "0 0 16.725 24.166"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "m11.584 4.763 1.714.214v4.056l-1.714.214zm-3.427-.429 1.713.214v4.913l-1.713.214zM4.73 3.906l1.713.214v5.77l-1.713.214zM3.302 2l12.674 1.585a.855.855 0 0 1 .749.85v5.141c0 .432-.32.795-.749.85L3.302 12.01zM2.32 24.151a.9.9 0 0 1-.319 0zM1 0a1 1 0 0 1 1 1v22a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1",
  clipRule: "evenodd"
})));
export default SvgWeatherStrongWind;